import type { SplitTestConfig } from '../splitTestTypes';
import { RAW_LEVELS } from '../../../../levels';
import { adRawLevels } from '../../../../levels/HS-892-levels/ad-blockers/adRawLevels';
import { coinRawLevels } from '../../../../levels/HS-892-levels/coin-blockers/coinRawLevels';
import { adCoinRawLevels } from '../../../../levels/HS-892-levels/ad-coin-blockers/adCoinRawLevels';
import type { LevelData } from '../../../game/level/LevelData';

export const hs893AdCoinBlockersSplitTest: SplitTestConfig = {
  distributions: 4,
  newUserTestSlug: null,
  returningUserTestSlug: 'AdCoinBlockers_RU_HS893',
  onActive(_, distribution) {
    if (distribution === 1) return;

    let override: Partial<LevelData>[] | null = null;
    if (distribution === 2) {
      override = adRawLevels;
    }
    if (distribution === 3) {
      override = coinRawLevels;
    }
    if (distribution === 4) {
      override = adCoinRawLevels;
    }

    if (!override) return;

    RAW_LEVELS.length = 0;
    RAW_LEVELS.push(...override);
  },
};
